import * as Yup from 'yup';

export const validationschat = (anonymous: boolean) => {
    const validations: any = {
        email: Yup.string()
            .email('El correo es inválido')
            .required('El correo es obligatorio')
            .test('Validate Email', 'El correo es inválido', (value) => {
                const re =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(value).toLowerCase());
            }),
        emailComfirmation: Yup.string()
            .required('La confirmación de correo es obligatoria')
            .oneOf([Yup.ref('email')], 'Los correos no coinciden'),
        requestType: Yup.string().required('El tipo Solicitud es obligatorio'),
        requestClassification: Yup.string().required(
            'La clasificación de solicitud es obligatoria'
        ),
        description: Yup.string().required('La descripción es obligatoria'),
        acceptPolicy: Yup.boolean()
            .oneOf(
                [true],
                'Debe aceptar la política de privacidad y uso de datos personales'
            )
            .required(
                'Debe aceptar la política de privacidad y uso de datos personales'
            ),
        filesSize: Yup.number().max(25, 'Puede adjuntar maximo hasta 25MB'),
    };

    if (!anonymous) {
        validations.documentType = Yup.string().required(
            'El tipo de documento es obligatorio'
        );
        validations.document = Yup.string()
            .required('El documento es obligatorio')
            .matches(
                /^[A-Za-z\d-]+$/,
                'El campo debe tener caracteres alfanuméricos y guiones'
            )
            .min(6, 'El documento debe tener al menos 6 dígitos')
            .max(15, 'El documento no puede tener más de 15 dígitos');
        validations.fullName = Yup.string()
            .required(
                'El campo nombres y apellidos y/o razon Social es obligatorio'
            )
            .matches(/^[A-Za-z ]+$/, 'El nombre solo puede contener letras')
            .test(
                'NoNumbers',
                'El campo nombres y apellidos y/o razon Social no puede contener números',
                (value) => !/\d/.test(value)
            )
            .test(
                'Nospaces',
                'El campo nombres y apellidos y/o razon Social no puede contener solo espacios',
                (value) => value.trim().length !== 0
            );
        validations.address = Yup.string()
            .required('La dirección es obligatorio')
            .test(
                'Nospaces',
                'La dirección no puede contener solo espacios',
                (value) => value.trim().length !== 0
            );
        validations.phone = Yup.string()
            .required('El teléfono depositante es obligatorio')
            .matches(/^\d+$/, 'El campo debe ser numérico')
            .min(6, 'El teléfono depositante debe tener al menos 6 dígitos')
            .max(
                15,
                'El teléfono depositante no puede tener más de 15 dígitos'
            );
        validations.country = Yup.string().required(
            'El país de residencia es obligatorio'
        );
        validations.department = Yup.string().required(
            'El departamento es obligatorio'
        );
        validations.city = Yup.string().required('La ciudad es obligatoria');
    }

    return Yup.object(validations);
};

export const valuesChat = {
    documentType: '',
    document: '',
    fullName: '',
    address: '',
    phone: '',
    country: '',
    department: '',
    city: '',
    email: '',
    emailComfirmation: '',
    requestType: '',
    requestClassification: '',
    description: '',
    acceptPolicy: false,
    files: [],
    filesSize: 0,
};
